import React, { useState } from "react";
import "assets/scss/pages/_DesignSystemComponents.scss";
import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import { useParams } from "react-router-dom";
import { getComponentsSideData } from "assets/data/sideTabData";
import { useGlobalContext } from "context/GlobalContext";
import PreviewTabsComponent from "components/DesignSystemPage/TabsComponent/PreviewTabsComponent";
import UsageTabComponent from "components/DesignSystemPage/TabsComponent/UsageTabComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";
import { tabTokenTabData } from "assets/data/tokenTabData";

const TabsComponents = () => {
  const { id } = useParams();
  const { designSystemMeta, designSystem } = useGlobalContext();
       
      const componentName = "tab";
      const componentKey = `Component/${componentName}`;
      const componentData = designSystem[componentKey];
      const tokenTableData = tabTokenTabData(componentData, componentName);

  const [selectedTab, setSelectedTab] = useState(0);
  const bannerData = {
    heading: "Tab",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };
  const tabs = ["Preview", "Usage", "Tokens"];

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <PreviewTabsComponent setSelectedTab={setSelectedTab} />
        );
      case 1:
        return (
          <div>
            {/* <UsageEditor pageType={"tab_usage"} /> */}
            <UsageTabComponent/>
          </div>
        );
      case 2:
         return <TokenTableComponent tokenTableData={tokenTableData} />;
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title='Components'
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default TabsComponents;
